import { StatusBar } from 'expo-status-bar';
import { SafeAreaView, StyleSheet, Text, View } from 'react-native';
import { NavigationContainer } from '@react-navigation/native';
import { createStackNavigator } from '@react-navigation/stack';
import LoginView from './login_view';
import PasswordResetView from './password_reset_view'
import AddUserView from './add_user_view'
import EditWordView from './edit_word_view'
import WordsView from './words_view';
import WordnikView from './wordnik_view';
import FlashCardsView from './flash_cards_view';
import Styles from './styles';
const Stack = createStackNavigator();

export default function App() {
  return (
     <NavigationContainer>
      <Stack.Navigator initialRouteName="Login">
        <Stack.Screen name="Login" component={LoginView} />
        <Stack.Screen name="PasswordReset" component={PasswordResetView} />
        <Stack.Screen name="AddUser" component={AddUserView} />
        <Stack.Screen name="Words" component={WordsView} />
        <Stack.Screen name="Wordnik" component={WordnikView} />
        <Stack.Screen name="FlashCards" component={FlashCardsView} />
        <Stack.Screen name="EditWord" component={EditWordView} />
      </Stack.Navigator>
    </NavigationContainer>
  );
}

/*<View style={styles.container}>
  <Text>Open up App.js to start working on your app!</Text>
  <StatusBar style="auto" />
</View>*/

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#fff',
    alignItems: 'center',
    justifyContent: 'center',
  },
});
